export default "__VITE_ASSET__nuuf1Hg0__"